<template>
  <div class="py-20">
    <div class="container mx-auto px-6">
      <div class="mx-auto max-w-7xl">
        <div class="grid grid-cols-1 gap-12 lg:grid-cols-2">
          <!-- Service Description -->
          <div>
            <h2 class="mb-6 text-3xl font-bold text-ternary-dark dark:text-primary-light">
              What We Deliver
            </h2>
            <div class="space-y-6">
              <p
                v-for="(paragraph, index) in description"
                :key="index"
                class="text-lg text-gray-600 dark:text-gray-400"
              >
                {{ paragraph }}
              </p>
            </div>
          </div>

          <!-- Key Features -->
          <div>
            <h3 class="mb-6 text-2xl font-bold text-ternary-dark dark:text-primary-light">
              Key Features
            </h3>
            <div class="space-y-4">
              <div
                v-for="(feature, index) in features"
                :key="index"
                class="flex items-start space-x-3"
              >
                <div class="flex size-6 items-center justify-center rounded-full bg-gradient-to-r from-accent to-gradient-end">
                  <PhCheck class="size-4 text-white" />
                </div>
                <span class="text-gray-600 dark:text-gray-400">{{ feature }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PhCheck } from '@phosphor-icons/vue'

interface Props {
  description: string[]
  features: string[]
}

defineProps<Props>()
</script>
